// extracted by mini-css-extract-plugin
export default {"container":"a4rCfW4xf4SrcWNdHofd"};